import styled from '@emotion/styled/macro';
import { Variables } from '../../../base/variables';
import * as Shared from '../form.styles';

export const FormContainer = styled(Shared.FormContainer)`
    position: relative;
`;
export const FormGrid = Shared.FormGrid;
export const FormField = Shared.FormField;
export const Label = Shared.Label;
export const Input = Shared.Input;
export const Select = Shared.Select;
export const ErrorMessage = Shared.ErrorMessage;
export const AutocompleteContainer = Shared.AutocompleteContainer;
export const AutocompleteDropdown = Shared.AutocompleteDropdown;
export const AutocompleteOption = Shared.AutocompleteOption;
export const LoadingText = Shared.LoadingText;
export const NoResults = Shared.NoResults;

export const SavingIndicatorWrapper = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 10;
`;

export const SavingIndicator = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    background-color: ${Variables.Colors.n15_24};
    border-radius: 4px;
    font-size: 12px;
    color: ${Variables.Colors.n70};
    white-space: nowrap;
`;

